import {FrameworkHttpService} from '../framework/http/service';
import {Injectable} from '@angular/core';
import {Cast} from '../framework/cast';
import {environment} from '../../environments/environment';
import {AppUser, AppUserData} from '../framework/AppUser';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FileInfo} from '../framework/ui/uploader';


@Injectable()
export class QARService extends FrameworkHttpService {

	public systemLoaderUpload(systemId: number, file: FileInfo) {
		return this.POST(environment.api.qar.url + 'systems/' + systemId + '/upload', {FileName: file.name, Base64: file.base64}, null, false);
	}

	public saveSystemRoleGroupForSORUserId(userId: number, groupIds: number[]) {
		return this.POST(environment.api.qar.url + 'sor-users/' + userId + '/assign-system-role-group', {SystemRoleGroupIds: groupIds}, null, false);
	}

	public pairRoles(name: string, systemId: number, roleIds: number[]) {
		return this.POST(environment.api.qar.url + 'system-roles/pairing', {roleIds, systemId, name}, null, false);
	}

	public unpairRoles(pairingId: number) {
		return this.POST(environment.api.qar.url + 'system-roles/unpairing', {pairingId}, null, false);
	}

	public retrieveDashboard(): Promise<DashboardResponse> {

		return this.GET(environment.api.qar.url + 'dashboard/all', DashboardResponse, false);
	}

	public retrieveInactiveUsers(): Promise<any[]> {

		return this._get(environment.api.qar.url + 'sor-users/inactive-users-in-batches').toPromise();

	}

	public retrieveLoadersLog() {
		return this.GET(environment.api.qar.url + 'dashboard/loader-log', SystemLoaderEntity);
	}

	// tools : user access
	public findApproversMissingAccess() {
		return this._get(environment.api.qar.url + 'tools/check-approvers-access').toPromise();
	}

	public retrieveUsersAccess() {
		return this._get(environment.api.qar.url + 'tools/users-access').toPromise();
	}

	// approval requests
	public retrieveApprovalRequest(id) {
		return this.GET(environment.api.qar.url + 'approval-requests/' + id, ApprovalRequestEntity, false);
	}

	public retrieveApprovalRequests() {
		return this.GET(environment.api.qar.url + 'approval-requests/all', ApprovalRequestEntity);
	}

	public retrieveApprovalRequestsToChase() {
		return this.GET(environment.api.qar.url + 'approval-requests/to-chase', ApprovalRequestEntity);
	}

	public decisionOnApprovalRequest(id, statusId, comments) {
		return this.PUT(environment.api.qar.url + 'approval-requests/' + id, {
			StatusId: statusId,
			Comments: comments
		}, ApprovalRequestEntity, false);
	}

	public counterSignApprovalRequest(request: ApprovalRequestEntity) {
		return this.POST(environment.api.qar.url + 'approval-requests/' + request.Id + '/counter-sign', {CounterSigningComments: request.CounterSigningComments}, ApprovalRequestEntity, false);
	}

	public cancelApprovalRequest(id) {
		return this.POST(environment.api.qar.url + 'approval-requests/' + id + '/cancel', {}, ApprovalRequestEntity, false);
	}

	public reinstateApprovalRequest(id) {
		return this.POST(environment.api.qar.url + 'approval-requests/' + id + '/reinstate', {}, ApprovalRequestEntity, false);
	}

	public reassignApprovalRequest(id, UserId) {
		return this.POST(environment.api.qar.url + 'approval-requests/' + id + '/reassign', {User: {Id: UserId}}, ApprovalRequestEntity, false);
	}

	public uploadOnApprovalRequest(id, files) {
		return this.PUT(environment.api.qar.url + 'approval-requests/' + id, {
			Attachments: files
		}, ApprovalRequestEntity, false);
	}

	public approvalRequestNewBatch(Type, Reference, Description, EmailSubject, EmailBody, userList, uploadedFile, PossibleStatuses, canCounterSign) {
		return this.POST(environment.api.qar.url + 'approval-requests/create-batch', {
			Type,
			Reference,
			Description,
			EmailSubject,
			EmailBody,
			Users: userList,
			File: uploadedFile,
			PossibleStatuses,
			NeedCountersigning: canCounterSign
		}, false, false);
	}


	// soc clashes
	public addNoteToSODClash(clashId, message, decision, filesAsBase64: string[], validUntil = null): Promise<any> {
		return this.POST(environment.api.qar.url + 'sod-clashes/' + clashId + '/notes', {
			message,
			decision,
			validUntil,
			files: filesAsBase64
		}, false, false);
	}

	public retrieveSODClashes(): Promise<SODClashEntity[]> {
		return this.GET(environment.api.qar.url + 'sod-clashes/all', SODClashEntity);
	}

	public retrieveSODClashNotes(id): Promise<SODClashNoteEntity[]> {
		return this.GET(environment.api.qar.url + 'sod-clashes/' + id + '/notes', SODClashNoteEntity);
	}

	// mappings
	public saveApproverOverrides(sorUserId, sorManagerOverrideId): Promise<SORUserEntity[]> {
		return this.POST(environment.api.qar.url + 'sor-users/overriden', {
			sorUserId,
			sorManagerOverrideId
		}, false, false);
	}

	public deleteApproverOverride(id): Promise<SORUserEntity[]> {
		return this.DELETE(environment.api.qar.url + 'sor-users/' + id + '/overriden', false, false);
	}

	public updateApproverOverride(Id, OverridenManagerComments): Promise<SORUserEntity[]> {
		return this.POST(environment.api.qar.url + 'sor-users/overriden/comments', {
			Id,
			OverridenManagerComments
		}, false, false);
	}

	public retrieveApproverOverrides(): Promise<SORUserEntity[]> {
		return this.GET(environment.api.qar.url + 'sor-users/overriden', SORUserEntity, true);
	}


	// chasing
	public sendChasingEmail(participationId, message, who, important, copyAuditTeam) {
		return this.POST(environment.api.qar.url + 'qar-report-chasing/participation/' + participationId + '/chasing-email', {
			Message: message,
			Who: who,
			Important: important,
			CopyAuditTeam: copyAuditTeam
		}, ReportParticipationEntity, false);
	}

	// Approval request chasing
	public sendApprovalRequestChasingEmail(approvalRequestId, message, who, important, copyAuditTeam) {
		return this.POST(environment.api.qar.url + 'approval-requests/' + approvalRequestId + '/chasing-email', {
			Message: message,
			Who: who,
			Important: important,
			CopyAuditTeam: copyAuditTeam
		}, ReportParticipationEntity, false);
	}


	public saveReportParticipationChasingComment(participationId, comment): Promise<ReportParticipationEntity> {
		return this.PUT(environment.api.qar.url + 'qar-report-chasing/participation/' + participationId + '/chasing', {ChasingComment: comment}, ReportParticipationEntity, false);
	}

	public retrieveQARReportsParticipationsForChasingForReportId(id): Promise<ReportParticipationEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-report-chasing/' + id, ReportParticipationEntity);
	}

	// reports
	public reports_saveRow(participationId, row) {

		return this.POST(environment.api.qar.url + 'qar-reports/participation/' + participationId + '/rows', {
			rows: [row]
		}, false, false);
	}

	public reports_markAsComplete(participationId) {
		return this.POST(environment.api.qar.url + 'qar-reports/participation/' + participationId, {complete: true}, false, false);
	}

	public reports_markAsCountersigned(participationId, notes) {
		return this.POST(environment.api.qar.url + 'qar-reports/participation/' + participationId, {
			counterSigned: true,
			notes
		}, false, false);
	}

	public reports_retrieveRowsForParticipationId(participationId): Promise<ReportRowEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/participation/' + participationId + '/rows', ReportRowEntity);
	}

	public reports_retrieveParticipation(participationId, cb401?: () => void): Promise<ReportParticipationEntity> {
		return this.GET(environment.api.qar.url + 'qar-reports/participation/' + participationId, ReportParticipationEntity, false, cb401);
	}

	public reports_rowBySORUserId(reportId, sorUserId): Promise<ReportRowEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/' + reportId + '/last-time/rows/by-sor-user/' + sorUserId, ReportRowEntity);
	}

	public retrieveUserRolesAtDate(sorUserId, todate): Promise<SORUserRoleAtDate[]> {
		return this.GET(environment.api.qar.url + 'sor-users/' + sorUserId + '/systems-batches-rows/' + (todate ? todate : ''), SORUserRoleAtDate);
	}


	public retrieveCurrentQARReportRejectedUsers(reportId): Promise<ReportRowEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/' + (reportId === 'latest' ? -1 : reportId) + '/rejected-users', ReportRowEntity);
	}

	public updateRejectedUserComments(reportId, id, comment): Promise<ReportRowEntity[]> {
		return this.POST(environment.api.qar.url + 'qar-reports/' + reportId + '/rows/' + id + '/user-rejected-comment', {
			Id: id,
			RejectedUserComments: comment
		}, false, false);
	}

	// Update Last status of rejevcted user
	public lastKnowStatusOfUserAccess(reportRowId: number, status: string) {
		return this.POST(environment.api.qar.url + 'qar-reports/last-known-status/' + reportRowId, {
			recentStatus: status
		}, false, false);
	}

	public testIfAccessHasBeenRemoved(systemBatchRowIds: number[]) {
		return new Promise((ok, err) => {
			// 200 means access has been removed, 409 that it still exists
			this.POST(environment.api.qar.url + 'systems/loaders-dry-run', systemBatchRowIds, false, false, null, () => {
				// 409, access was found
				// ok(409);
				ok(false);
			}).then((result) => {
				ok(result);
			}).catch(e => {
				err(e);
			});
		});
	}

	/*
	public saveReportForApprover(participationId, rows): Promise<ReportRowEntity[]> {
		return this.POST(environment.api.qar.url + 'qar-reports/participation/' + participationId + '/rows', {
			rows
		}, false, false);
	}
	*/
	public unassignReportApprovers(partipationId) {
		return this.POST(environment.api.qar.url + 'qar-reports/participation/' + partipationId + '/unassign-approver', {}, false, false);
	}

	public reassignReportApprovers(toUserId, fromUserIds) {
		const fromUserIdsAsInt = [];
		for (const fu of fromUserIds) {
			fromUserIdsAsInt.push(parseInt(fu, 0));
		}
		return this.POST(environment.api.qar.url + 'qar-reports/latest/reassign-approvers', {
			participationIdsToReassign: fromUserIdsAsInt,
			toApproverId: toUserId
		}, false, false);
	}

	public retrieveCurrentQARReport(cb409?: () => void): Promise<ReportEntity> {
		return this.GET(environment.api.qar.url + 'qar-reports/latest', ReportEntity, false, null, cb409);
	}

	public retrieveQARReportsBrowserRows(reportId): Promise<ReportParticipationEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/' + (reportId === 'latest' ? -1 : reportId) + '/report-browser', ReportParticipationEntity, true);
	}

	public prepareDownloadSystemAccessReportExcelURL(reportId) {
		const url = environment.api.qar.url + 'qar-reports/' + reportId + '/to-excel-file';
		return this.GET(url, false);
	}

	public downloadSystemAccessReportExcelURL(reportId, code): string {
		return environment.api.qar.url + 'qar-reports/' + reportId + '/to-excel-file/' + code;
	}

	public retrieveQARReportsRows(reportId): Promise<QueryForSystemAccessReportEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/' + reportId + '/rows', QueryForSystemAccessReportEntity);
	}

	public retrieveQARReportsForReportBrowser(): Promise<ReportEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/all-for-report-browser', ReportEntity);
	}

	public retrieveQARReports(): Promise<ReportEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/all', ReportEntity);
	}

	public retrieveQARReportsForReassignment(): Promise<ReportEntity[]> {
		return this.GET(environment.api.qar.url + 'qar-reports/all-for-reassignment', ReportEntity);
	}

	// role
	public addRoleToSystem(systemId, newRoleName) {
		return this.PUT(environment.api.qar.url + 'systems/' + systemId + '/roles', {
			Name: newRoleName
		}, SystemRoleEntity);
	}

	public retrieveSystemsRolesForSystemId(systemId): Promise<SystemRoleEntity[]> {
		return this.GET(environment.api.qar.url + 'systems/' + systemId + '/roles', SystemRoleEntity);
	}

	public retrieveSystemRoleAuditLog(roleId) {
		return this.GET(environment.api.qar.url + 'audit-logs/system-roles/' + roleId, AuditLogEntity);
	}


	public retrieveSystemRoleBatches(roleId) {
		return this.GET(environment.api.qar.url + 'system-roles/' + roleId + '/first-and-last-used-date', false);
	}

	public updateRole(roleId, sodRequired, mappedName, description, deprecated): Promise<any> {
		console.log(roleId, sodRequired, mappedName);
		return this.PUT(environment.api.qar.url + 'system-roles/' + roleId, {
			mappedName,
			sodRequired,
			description,
			deprecated
		}, false, false);
	}

	public removeClashToRole(roleId, clashRoleId): Promise<any> {
		return this.DELETE(environment.api.qar.url + 'system-roles/' + roleId + '/clashes/' + clashRoleId, false, false);
	}

	public addClashToRole(roleId, clashRoleId): Promise<any> {
		return this.POST(environment.api.qar.url + 'system-roles/' + roleId + '/clashes', {clashWith: {Id: parseInt(clashRoleId, 0)}}, false, false);
	}

	public retrieveAllRolesWithGroups(): Promise<SystemRoleEntity[]> {
		return this.GET(environment.api.qar.url + 'system-roles/with-groups', SystemRoleEntity);
	}

	public retrieveRoleWithGroups(id): Promise<SystemRoleEntity> {
		return this.GET(environment.api.qar.url + 'system-roles/' + id + '/with-groups', SystemRoleEntity, false);
	}

	public saveRoleGroups(id, groups): Promise<SystemRoleEntity> {
		return this.PUT(environment.api.qar.url + 'system-roles/' + id + '/with-groups', groups, SystemRoleEntity, false);
	}

	public userRolesAutoReconciliationStart(systemId): Promise<AutoReconciliationRow[]> {
		return this.POST(environment.api.qar.url + 'system-roles-groups/auto-rec-system/' + systemId, {}, AutoReconciliationRow, true);
	}

	// !retrieveRolesWithClashCount
	public retrieveRolesWithClashCount(): Promise<SystemRoleWithClashCountResult[]> {
		return this.GET(environment.api.qar.url + 'system-roles/with-clashes-count', SystemRoleWithClashCountResult);
	}

	public retrieveRolesThatClashesWith(roleId) {
		return this.GET(environment.api.qar.url + 'system-roles/' + roleId + '/clashes', SystemRoleWithClashCountResult);
	}

	public retrieveAllRoleGroups(): Promise<SystemRoleGroupEntity[]> {
		return this.GET(environment.api.qar.url + 'system-roles-groups/all', SystemRoleGroupEntity);
	}

	// !SPECIAL
	public searchSORUser(search: string, extended = false): Observable<SORUserEntity[]> {
		return this.http.post(environment.api.qar.url + 'sor-users/search', {search, extended}, {headers: this.getHeaders()}) as Observable<SORUserEntity[]>;
	}

	public retrieveSORUserById(id: number): Observable<SORUserEntity> {
		return this.http.get(environment.api.qar.url + 'sor-users/' + id, {headers: this.getHeaders()}) as Observable<SORUserEntity>;
	}

	public searchSystemRole(search: string): Observable<SystemRoleEntity[]> {
		return this.http.post(environment.api.qar.url + 'system-roles/search', {search}, {headers: this.getHeaders()}) as Observable<SystemRoleEntity[]>;
	}

	// settings chasing plan
	public retrieveSettingsChasingPlan(): Promise<ChasingPlanSettings> {
		return this.GET(environment.api.qar.url + 'settings/chasing-plan', ChasingPlanSettings, false);
	}

	public saveSettingsChasingPlan(settings: ChasingPlanSettings): Promise<ChasingPlanSettings> {
		settings.reminder1AfterXDays = parseInt('' + (settings.reminder1AfterXDays ? settings.reminder1AfterXDays : 1), 0);
		settings.reminder2AfterXDays = parseInt('' + (settings.reminder2AfterXDays ? settings.reminder2AfterXDays : 1), 0);
		settings.reminder3AfterXDays = parseInt('' + (settings.reminder3AfterXDays ? settings.reminder3AfterXDays : 1), 0);
		return this.PUT(environment.api.qar.url + 'settings/chasing-plan', settings, ChasingPlanSettings, false);
	}

	public validateEmail(email): Promise<ValidateEmailResponse> {
		return this.POST(environment.api.qar.url + 'settings/validate-email', {Email: email}, ValidateEmailResponse, false);
	}

	// others
	public retrieveSettingsOthers() {
		return this._get(environment.api.qar.url + 'settings/others').toPromise();
	}

	public saveSettingsOthers(settings): Promise<void> {
		return this.PUT(environment.api.qar.url + 'settings/others', settings, null, false);
	}

	// rejection
	public retrieveSettingsRejection(): Promise<string[]> {
		return this._get(environment.api.qar.url + 'settings/rejection-reasons').toPromise();
	}

	public saveSettingsRejection(settings: string[]): Promise<any> {
		return this.PUT(environment.api.qar.url + 'settings/rejection-reasons', settings, null, false);
	}

	// sod clash
	public retrieveSettingsSODClash(): Promise<string[]> {
		return this._get(environment.api.qar.url + 'settings/sod-clash-report').toPromise();
	}

	public saveSettingsSODClash(settings: string[]): Promise<any> {
		return this.PUT(environment.api.qar.url + 'settings/sod-clash-report', settings, null, false);
	}


	//
	public retrieveSettingsReportSchedule(): Promise<ReportScheduleSetting[]> {
		return this.GET(environment.api.qar.url + 'settings/report-schedules', ReportScheduleSetting, true);
	}

	public addSettingsReportSchedule(reportType, date) {
		return this.POST(environment.api.qar.url + 'settings/report-schedules', {Date: date, ReportType: reportType}, false);
	}

	public deleteSettingsReportSchedule(id) {
		return this.DELETE(environment.api.qar.url + 'settings/report-schedules/' + id, false);
	}

	public deleteReport(id) {
		return this.DELETE(environment.api.qar.url + 'qar-reports/Delete-report-by-id/' + id, false);
	}

	public sodCheck(sorUserId, systemRoleId): Promise<SODCheckResult[]> {
		return this.POST(environment.api.qar.url + 'sod/check', {
			sorUserId,
			systemRoleId
		}, SODCheckResult, false);
	}

	public retrieveSystemRoles(): Promise<SystemRoleEntity[]> {
		return this.GET(environment.api.qar.url + 'crud/system-roles', SystemRoleEntity);
	}

	public retrieveUsers(): Promise<SORUserEntity[]> {
		return this.GET(environment.api.qar.url + 'crud/sor-users', SORUserEntity);
	}

	// !LOCAL ALIAS MAPPINGS
	public retrieveLocalAliasMappings(): Promise<MappingSystemUser2SORUserEntity[]> {
		return this.GET(environment.api.qar.url + 'crud/mapping-system-users', MappingSystemUser2SORUserEntity);
	}

	public deleteLocalAliasMapping(entry: MappingSystemUser2SORUserEntity) {
		return this.DELETE(environment.api.qar.url + 'crud/mapping-system-users/' + entry.Id, false, false);
	}

	public saveLocalAlias(systemId, username, sorUserId) {
		return this.POST(environment.api.qar.url + 'crud/mapping-system-users', {
			systemId, username, sorUserId
		}, false, false);
	}

	// !SYSTEM
	public systemAdd(systemEntity: SystemEntity): Promise<SystemEntity> {
		return this.POST(environment.api.qar.url + 'systems/add', {Name: systemEntity.Name}, SystemLoaderEntity, false);
	}

	public retrieveSystems(): Promise<SystemEntity[]> {
		return this.GET(environment.api.qar.url + 'systems/all', SystemEntity);
	}


	public retrieveSystemConfiguration(systemId): Promise<string> {
		return this._get(environment.api.qar.url + 'systems/' + systemId + '/configuration').toPromise();
	}

	public updateLoader(systemId, loaderId, isDeleted): Promise<SystemLoaderEntity> {
		return this.PUT(environment.api.qar.url + 'systems/' + systemId + '/loader/' + loaderId, {IsDeleted: isDeleted}, SystemLoaderEntity, false);
	}

	public updateSystem(system: SystemEntity): Promise<SystemEntity> {
		return this.PUT(environment.api.qar.url + 'systems/' + system.Id, system, SystemEntity, false);
	}

	public systemAddLoader(systemId: number, loader: SystemLoaderEntity): Promise<SystemLoaderEntity> {
		return this.POST(environment.api.qar.url + 'systems/' + systemId + '/loader', loader, SystemLoaderEntity, false);
	}

	public systemLoaderDryRun(systemId, loaderId) {
		return this.POST(environment.api.qar.url + 'systems/' + systemId + '/loader/' + loaderId + '/test', {}, SystemBatchRowEntity);
	}

	public systemLoaderDryRunRaw(systemId, loaderId): Promise<string> {
		return this.POST(environment.api.qar.url + 'systems/' + systemId + '/loader/' + loaderId + '/test-raw', {}, null, false);
	}

	public systemSODReportDryRunURL(systemId) {
		return environment.api.qar.url + 'systems/' + systemId + '/sod-report/test';
	}

	public systemLoaderDryRunForRoles(systemId, loaderId) {
		return this.POST(environment.api.qar.url + 'systems/' + systemId + '/loader/' + loaderId + '/test-roles', {}, SystemRoleEntity);
	}

	public systemDeleteLoader(systemId, loaderId) {
		return this.DELETE(environment.api.qar.url + 'systems/' + systemId + '/loader/' + loaderId, false, false);
	}

	// !ANOMALIES
	public retrieveAnomalies(): Promise<AnomalyResult[]> {
		return this.GET(environment.api.qar.url + 'anomalies/latest', AnomalyResult);
	}

	public updateAnomaliesComments(Id, Comments): Promise<SORUserEntity[]> {
		return this.POST(environment.api.qar.url + 'anomalies/comments', {
			Id,
			Comments
		}, false, false);
	}

	// !BLACKLIST
	public retrieveBlacklist(): Promise<SystemLoaderUserBlacklistEntity> {
		return this.GET(environment.api.qar.url + 'systems-loader-user-blacklist/all', SystemLoaderUserBlacklistEntity);
	}

	public deleteBlacklist(id): Promise<null> {
		return this.DELETE(environment.api.qar.url + 'systems-loader-user-blacklist/' + id, false, false);

	}

	public saveBlacklist(entry: SystemLoaderUserBlacklistEntity, nullRole: boolean) {
		return this.POST(environment.api.qar.url + 'systems-loader-user-blacklist/add', {
			SystemLoaderId: parseInt(entry.SystemLoaderId, 0),
			UserName: entry.UserName,
			RoleName: entry.RoleName,
			Reason: entry.Reason,
			NullRole: nullRole
		}, false);
	}

	// Audit log
	public retrieveQARAuditLogs(): Promise<AuditLogEntity[]> {
		return this.GET(environment.api.qar.url + 'audit-logs/all', AuditLogEntity);
	}

	public retrieveQARAuditLogsFilter(todate, fromdate) {
		return this.POST(environment.api.qar.url + 'audit-logs/filterbydate', {
			todate, fromdate
		}, false, false);
	}

	public deleteQARAuditLog(id): Promise<AuditLogEntity[]> {
		return this.DELETE(environment.api.qar.url + 'audit-logs/' + id, false, false);
	}
}


export class SORUserRoleAtDate {
	public SystemName; // ": "Pega Finance",
	public UserLogin; // ": "ACALVAYRAC",
	public Username; // ": "ACALVAYRAC",
	public RoleName; // ": "PASFinance:Underwriter",
	public MappedRoleName; // ": "Access Group: Underwriter",
	public FirstReported; // ": "2021-04-14T00:00:00",
	public LastReported; // ": "2022-07-03T00:00:00"
	public AdGroupName: string = null;
}

export class AutoReconciliationRow {
	public ActualRolesIds = [];
	public GroupIdCount = {};
	public RoleIds = [];
	public User: SORUserEntity;
	/*
	GroupIdCount: {3: 1, 5: 1, 6: 1, 8: 1}
	RoleIds: [27, 21, 22, 24, 23]
	0: 27
	1: 21
	2: 22
	3: 24
	4: 23
	User: {Id: 266, Login: "ARIESTRA", IsActive: true, FirstName: "Alexia", LastName: "Riestra",…}
	CreatedDate: "2022-07-14T11:11:22.3532994+02:00"
	Email: "ARIESTRA@tmhcc.com"
	FirstName: "Alexia"
	Id: 266
	IsActive: true
	LastName: "Riestra"
	Login: "ARIESTRA"
	Manager: null
	ManagerId: 1692
	OverridenManager: null
	OverridenManagerComments: null
	OverridenManagerId: null
	StatusId: null
	Title: "Claims Adjuster"
	UpdatedDate: "2022-07-12T12:53:49.8516817"
	*/
}

export class SystemLoaderUserBlacklistEntity {
	public Id; // : 23
	public RoleName; // : "UK-RMS Admin"
	public SystemLoader: SystemLoaderEntity; // {Id: 7, Name: "AD", Type: "AD", SystemId: 11, System: null, IsDeleted: false,…}
	public SystemLoaderId; // : 7
	public UserName; // : "svc-RL21P"
	public IsDeleted; // = from.IsDeleted,
	public CreatedDate; // = from.CreatedDate,
	public Reason; // = from.Reason,
}

export class DashboardResponse {
	public UnsolvedAnomalyCount;
	// number of roles to map
	public RolesToMapCount;
	// number of SOD clashes
	public SODClashesCount;
	//  how many to chase
	public QARReportsToChase;
	// how many approval requests to chase
	public ApprovalRequestsToChase;
	// errors in audit log in the past 2 - 3 days
	public AuditLogErrors;

}

export class ValidateEmailResponse {
	public valid = false;
}

export class SODClashNoteEntity {
	public CreatedBy;
	public DateCreated;
	public Message;
}

export class SODClashEntity {
	public Id;
	public ApprovedBy;
	public ApprovedDate;
	public DateCreated;
	public StatusId;
	public SORUser: SORUserEntity;
	public SODClashDefinition: SODClashDefinitionEntity;
}

export class SODClashDefinitionEntity {
	/*"Id": 1,
					"Reason": null,
					"SystemRoleId1": 1,
					"SystemRole1": null,
					"SystemRoleId2": 1,
					"SystemRole2": null,
					"CreatedBy": null,
					"CreatedDate": "2020-08-24T11:21:50.493",
					"DeletedBy": null,
					"DeletedDate": null,
					"IsDeleted": false*/
	public SystemRole1: SystemRoleEntity;
	public SystemRole2: SystemRoleEntity;
}

export class ReportRowEntity {
	public SystemBatchRow: SystemBatchRowEntity;
	public StatusId;
	public RejectionReason;
	public OverridenRejectionReason;
	public OverridenStatusId;
	public LastCheckedStatus;
	public LastCheckedDate;
	public Id;
	public AdGroup: string = null;

	public static reasons = {
		access_not_required: 'Access Not Required',
		user_left_organisation: 'User Has Left Organisation',
		// user_has_moved_team: 'User Has Moved Team',
		user_unknown: 'User Unknown',
		user_has_moved_team_access_not_required: 'User has moved to my team and does not need this access',
		user_has_moved_team_cannot_answer: 'User has moved away from my team and I cannot review this access',
	};
	public static reasonsKeyValues = [
		{key: null, value: 'Rejection Reason'},
		{key: 'access_not_required', value: 'Access Not Required'},
		{key: 'user_left_organisation', value: 'User Has Left Organisation'},
		// {key: 'user_has_moved_team', value: 'User Has Moved Team'},
		{key: 'user_unknown', value: 'User Unknown'},
		{key: 'user_has_moved_team_access_not_required', value: 'User has moved to my team and does not need this access'},
		{key: 'user_has_moved_team_cannot_answer', value: 'User has moved away from my team and I cannot review this access'},
	];

	public RejectedUserComments;
}

export class ReportParticipationEntity {
	public Id;
	public StatusId;
	public CompletedBy;
	public ChasingNotes;
	public LastChasedDate;
	public Notes;
	public CompletedDate;
	public CounterSignedBy;
	public CounterSignedDate;
	public SORUserApprover: SORUserEntity = new SORUserEntity();
	public SORUserOverridenApprover: SORUserEntity = new SORUserEntity();
	public SORUserOverridenApproverId;
	public SORUserOverridenApproverDate;
	public Report: ReportEntity = new ReportEntity();
	public Systems: string[] = [];
}

export class QueryForSystemAccessReportEntity {
	public SystemName;
	public UserFirstName;
	public UserLastName;
	public SystemRoleName;
	public SystemRoleMappedName;
	public ApproverFirstName;
	public ApproverLastName;
	public ApprovalDate;
	public CounterSignDate;
	public CounterSigner;
	public StatusId;
}

export class ReportEntity {
	public Id;
	public Type;
	public Name;
	public Year;
	public StatusId;
	public ClosedDate;
	public CreatedDate;
	/*
	 "Id": 1,
			"StatusId": "open",
			"Type": "QAR",
			"Name": "Q3",
			"Year": 2020,
			"EmailDistributionDone": false,
			"AnomalyReportCreated": false,
			"ClosedDate": null,
			"CreatedBy": "system",
			"CreatedDate": "2020-08-19T20:02:17.8345083",
			"DeletedBy": null,
			"DeletedDate": null,
			"IsDeleted": false
	 */
}

export class AuditLogEntity {
	public Id;
	public CreatedDate;
	public Path;
	public Log;
	public Json;
}

export class SystemRoleWithClashCountResult {
	public SystemRoleId;
	public SystemId;
	public SystemName;
	public SystemRoleName;
	public SystemRoleMappedName;
	public SystemRoleSODRequired;
	public SystemRoleMappedDate;
	public SystemRoleMappedBy;
	public ClashesCount;
	public SystemRoleDescription;
	public SystemRoleDeprecated;
}


export class MappingSystemUser2SORUserEntity {
	public Id;
	public UserNameInSystem;
	public SORUserId;
	public SORUser: SORUserEntity;
	public SystemId;
	public System: SystemEntity;
}

export class ChasingPlanSettings {
	public reminder1AfterXDays = 7;
	public reminder2AfterXDays = 7;
	public reminder3AfterXDays = 7;
	public reminder1Active = true;
	public reminder2Active = true;
	public reminder3Active = true;
	public reminderEmail = 'bcndev@tmhcc.com';
}


export class ReportScheduleSetting {
	public report_type;
	public date;
}

export class SODCheckResult {
	public Clash = false;
	public ClashFrom: SystemRoleEntity;
	public ClashWith: SystemRoleEntity[] = [];
	public ErrorUserNotFound = false;
	public RoleId: any;
}

export class AnomalyResult {
	public Id;
	public SystemId;
	public SystemBatchRowId;
	public SystemName;
	public RoleName;
	public LocalAlias;
	public FirstName;
	public LastName;
	public Type;
	public CreatedDate;
	public SystemRoleId;
	public SystemRoleMappedName;
	public SORUserId;
	public SystemRoleSODRequired;
	public LineManagerFullName;
	public SystemBatchRowCreatedDate;

	public SystemBatchId;
	public SystemLoaderId;
	public SystemLoaderName;
	public Comments;
}

export class AnomalyEntity {
	public CreatedBy;
	public CreatedDate;
	public DeletedBy;
	public DeletedDate;
	public Id;
	public IsDeleted;
	public IsSolved;
	public Type;
	public Comments;

	public SystemBatchRowEntity: SystemBatchRowEntity = new SystemBatchRowEntity();

	public static TypeDescriptions = {
		SOD_ROLE_IS_NEW: 'New role. No mapping. No SOD',
		SOURCE_NO_ROLE: 'Missing role in source data',
		NO_APPROVER: 'No Approver can be found',
		USER_UNKNOWN: 'Unknown user',
		SOURCE_NO_USERNAME: 'User name is missing from the data',
		SOD_REQUIRED_BUT_NO_RULES: 'SOD Rule Required',
		TYPE_NO_USER_INFO_IN_AD: 'Missing User Name(s) in Active Directory',
	};

	public static HowToSolveDescriptions = {
		SOD_ROLE_IS_NEW: 'Please go to the System Roles & SOD page and map this role',
		SOURCE_NO_ROLE: 'This row for user + access should be removed from the source system',
		NO_APPROVER: 'This user has no manager in AD, you need to map the user on page Local User Aliases or blacklist it if it is a service account',
		USER_UNKNOWN: 'User could not be found, please map it in Local User Aliases or blacklist it if it is a service account',
		SOURCE_NO_USERNAME: 'User name is missing from the data, this should be removed from the source system',
		SOD_REQUIRED_BUT_NO_RULES: 'Please go to the System Roles & SOD page, if this role needs SOD rules please add them, otherwise please uncheck the "SOD required" checkbox',
		TYPE_NO_USER_INFO_IN_AD: 'Missing User Name(s) in Active Directory, please fix it in Active Directory',
	};

	public static TypeReasons = {
		SOURCE_NO_ROLE: 'SRC',
		SOURCE_NO_USERNAME: 'SRC',
		USER_UNKNOWN: 'USER',
		NO_APPROVER: 'APP',
		SOD_ROLE_IS_NEW: 'SOD',
		SOD_REQUIRED_BUT_NO_RULES: 'SOD',
		TYPE_NO_USER_INFO_IN_AD: 'AD'
	};
}

export class SORUserEntity {
	public Id;
	public FirstName;
	public LastName;
	public Login;
	public Office;
	public Email;
	public Title;
	public Manager;
	public OverridenManager: SORUserEntity;
	public OverridenManagerComments;
	public Country;
	public IsPrivilegedAccount;
	// Manager: any;

}

export class SystemBatchRowEntity {
	public Id;
	public UserName;
	public RoleName;
	public MappedRoleName;
	public IsUserPrivileged;
	public SORUser: SORUserEntity = new SORUserEntity();
	public SystemRole: SystemRoleEntity = new SystemRoleEntity();
	public SystemBatch: SystemBatchEntity = new SystemBatchEntity();
}

export class SystemBatchEntity {
	public Id;
	public SystemLoaderEntity: SystemLoaderEntity = new SystemLoaderEntity();
}

export class SystemLoaderEntity {
	public Id;
	public Name;
	public IsDeleted;
	public JSON;
	public EnrichAD;
	public Type = 'AD';
	public System: SystemEntity = new SystemEntity();
}

export class LoaderResult {
	public UserName;
	public RoleName;
}

export class SystemRoleEntity {
	public Id;
	public PairingId: number | null;
	public Name;
	public MappedName;
	public Description;
	public System: SystemEntity = new SystemEntity();
	public Pairing: PairingEntity = new PairingEntity();

	public AssignedGroups: SystemRole2GroupEntity[] = [];
}

export class PairingEntity {
	public Id;
	public Name;
	public SystemId;
}

export class SystemRoleGroupEntity {
	public Id;
	public Name;
}

export class SystemRole2GroupEntity {
	public SystemRoleId;
	public SystemRoleGroupId;

}

export class SystemEntity {
	public Id;
	public Name;
	public SodApprover;
	public Comments;
	public IncludeInQARReport;
	public IncludeInSODReport;
	public NeedsAnomalyCheck;
	public Loaders: SystemLoaderEntity[] = [];
}

export class ApprovalRequestEntity {
	public Id;
	public Type;
	public Description;
	public Filepath;
	public Reference;
	public Attachments;
	public StatusId;
	public Comments;
	public NeedCountersigning = false;
	public CounterSignedBy;
	public CounterSignedDate;
	public CounterSigningComments;
	public CreatedDate;
	public DecisionDate;
	public SORUserId;
	public SORUser: SORUserEntity;
}
